import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { Injectable } from "@angular/core";
import { ApiConfig } from "./config/api.config";
import { CoberturaEnExterior } from "../models/cobertura-en-exterior.model";

@Injectable()
export class CoverageAbroadService{
    constructor(
        private http: HttpClient,
        private api: ApiConfig,     
    ){}

    getInformacionCoberturaEnExterior() : Observable<Array<CoberturaEnExterior>> {
        return this.http.get<Array<CoberturaEnExterior>>(this.api.url + '/coverage-abroad/list');
    }
}


// WEBPACK FOOTER //
// /app/src/app/shared/services/coverage-abroad.service.ts